import { render } from "./kashtabroo.vue?vue&type=template&id=6fb81ffb"
import script from "./kashtabroo.vue?vue&type=script&lang=js"
export * from "./kashtabroo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/arair-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__